"use client";

import { useEffect } from "react";

import { useAssignSettingLoggedInHubsRSCM1 } from "@faire/retailer/settings/useSettingLoggedInHubsRSCM1";

export const MaybeAssignHubsRSCM1Setting: React.FC<{
  isHubsCategory: boolean;
}> = ({ isHubsCategory }) => {
  const assignHubsRSCSetting = useAssignSettingLoggedInHubsRSCM1();
  useEffect(() => {
    if (isHubsCategory) {
      assignHubsRSCSetting();
    }
  }, [assignHubsRSCSetting, isHubsCategory]);
  return null;
};
